<template>
    <div class="ngdialog-content">
        <dialog-header :showClose="false">
            <h4>{{ $t('moreNotifications.title') }}</h4>
        </dialog-header>

        <div class="ngdialog__body notification__list">
            <div v-for="(n, i) in data.notifications" :key="'notification_' + i" class="notification__item">
                <span class="notification__item__time">{{ formatDate(n.sent_at, 'Y-m-d H:i:s') }}</span>
                
                <span v-if="n.user" class="notification__item__user">{{ n.user.name }}</span>
                <span v-else class="notification__item__user">N/A</span>

                <span class="notification__item__type">
                    <i v-if="n.via_push" class="icon icon--push" style="margin-right:3px;"></i>
                    <i v-if="n.via_email" class="icon icon--mail" style="margin-right:3px;"></i>
                </span>
            </div>
        </div>

        <div class="ngdialog__button-group">
            <div class="ngdialog__button-group__item">
                <button
                    type="button"
                    class="ngdialog__button ngdialog__button--primary"
                    @click="close"
                >
                    <span class="ngdialog__button__text">{{ $t('buttons.close') }}</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import DialogHeader from '@/components/DialogHeader';
import formatDate from '@/mixins/formatDate';

export default {
    name: 'verify-user',
    mixins: [formatDate],
    components: {
        DialogHeader,
    },
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
    mounted() {
    },
    data() {
        let data = {
            info: false,
            info_title: 'notifications.sent',
            info_message: 'verifyuser.resend_verification_success_text',
            error: false,
            error_title: 'verifyuser.failed',
            error_message: 'verifyuser.not_yet_verified',
        };

        return data;
    },
    methods: {
        close() {
            this.$emit('close');
        },
    },
};
</script>